import { type Path } from 'react-hook-form';

import { type BlockedRecordProctorFormInput } from './blocked-record-proctor-form-schema';

type PathOfBlockedRecordProctorFormInput = Path<BlockedRecordProctorFormInput>;

export const BLOCKED_RECORD_PROCTOR_FIELDS_NAME = {
  blockedCourseType: 'blockedCourses.type',
  blockedCourseCourses: 'blockedCourses.courses',
  reason: 'reason',
} as const satisfies Record<string, PathOfBlockedRecordProctorFormInput>;
